import React from 'react';
import styles from './Assembly.module.scss';
import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import { Stepper } from '../../components';

const Assembly = () => {
  return (
		<>
			<Box className={styles.container} paddingX={3}>
				<Stepper>
					{(activeStep, handleNext) => (
						<Outlet context={{ activeStep, handleNext }} />
					)}
				</Stepper>
			</Box>
		</>
	);
};

Assembly.propTypes = {};

export default Assembly;
